import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createMarkup from '@medscape-promo/medscapetv/utils/create-markup';
import { EMBD_LNK } from '@medscape-promo/medscapetv/omniture-tracking';
const { setTimeout } = window;
class HtmlContent extends Component {
    constructor(props) {
        super(props);
        this.contentRef = React.createRef();
        //console.log("[HtmlContent] props:",props);
    }

    initTracking() {
        let { current: contentNode } = this.contentRef;
        const { tracking, linksTarget } = this.props;
        if (contentNode != null && tracking != null && tracking.trim() != "") {
            let links = [...contentNode.querySelectorAll('a')];

            links.forEach(linkEl => {
                    if(linksTarget.trim() !== "") {
                        linkEl.setAttribute('target',linksTarget);
                        if(linksTarget === "_blank") {
                            linkEl.setAttribute('rel','noreferrer');
                        }
                    }
                    linkEl.addEventListener('click', e => {
                    this.props.onOmnitureTracking(EMBD_LNK,linkEl);
                    
                    this.props.onLinkClick(e);
                })
            })
        }

    }
    componentDidUpdate(prevProps, prevState) {
        this.initTracking();
        this.props.onUpdated(this.contentRef);
        //console.log("[HtmlContent] Update:",this.contentRef.current);
    }
    componentDidMount() {
        this.initTracking();
        setTimeout(() => {
            this.props.onMounted(this.contentRef)
        },100);
        
    }
    render() {

        const {
            content,
            className,
            style,
            tagName: TagName,
            templateData,
            id
        } = this.props;
        let TemplateData = Object.assign({},templateData,{
            imageServerHost: this.props.imageServer.host
        })
        let tagProps = {
            id: id,
            className: `html-content ${className}`.trim(),
            style: style,
            dangerouslySetInnerHTML: createMarkup(content,TemplateData),
            ref: this.contentRef
        }


        return (
            <TagName {...tagProps} />
        )

    }

    static get propTypes() {
        return {
            "content": PropTypes.string,
            "className": PropTypes.string,
            "style": PropTypes.object,
            "tracking": PropTypes.string,
            "tagName": PropTypes.string,
            "templateData": PropTypes.object,
            "linksTarget": PropTypes.string,
            "onLinkClick": PropTypes.func,
            "onMounted": PropTypes.func,
            "onUpdated": PropTypes.func,
            "onOmnitureTracking": PropTypes.func,
            "id": PropTypes.string,
            "imageServer": PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            content: "",
            className: "",
            style: {},
            tracking: EMBD_LNK,
            tagName: "div",
            templateData: {},
            linksTarget: "",
            "onLinkClick": () => {},
            "onMounted": () => {},
            "onUpdated": () => {}


        }
    }
}


export default HtmlContent